export default __webpack_public_path__ + "static/media/DJI_0940.MP4.00_00_59_03.Still005.27ef1eec.jpg";